import Vue from 'vue/dist/vue.esm'
import MoveTo from 'moveto'

new Vue({
  el: '.gototop',
  data: {
    moveTo: null
  },
  methods: {
    clicked: function() {
      const target = document.getElementById('navbar');

      this.$el.classList.add('moving')
      Vue.nextTick(() => {
        this.moveTo.move(target);
      })
    },
    finished: function() {
      this.$el.classList.remove('moving')
    }
  },
  created: function() {
    this.moveTo = new MoveTo({
      callback: this.finished
    });
  }
})



// WEBPACK FOOTER //
// ./app/javascript/packs/top.js